import {baseDataApi} from '@/api';

/**
 *  首页
 */
const getDefaultState = () => {
  return {
    ukTenant: null
  };
};
const state = getDefaultState();

const mutations = {
  SET_UK_TENANT: (state, ukTenant) => {
    state.ukTenant = ukTenant;
  },
};

const actions = {
  getUkTenant({ commit, state, dispatch }) {
    return new Promise(async(resolve, reject) => {
      const res1 = await baseDataApi.getLovHeadersByLovCode({ lovCode: 'TENANT_COUNTRY'});
      const lovId = res1.lovId;
      const queryPrams = {
        lovCode: 'TENANT_COUNTRY',
        lovId,
        meaning: 'UK_SELLO'
      };
      baseDataApi.getLovValuesByLovId(queryPrams).then(res => {
        commit('SET_UK_TENANT', res.content[0]);
        resolve(res.content[0]);
      }).catch(error => {
        reject(error);
      });
    });
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
